import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from './services/user.service';
import { safeGetItem } from './services/safe-storage';

/**
 * Authentication guard — protects routes that require a logged-in user.
 *
 * Checks for both a valid session token and a current user in the
 * UserService. Redirects unauthenticated users to /login, preserving
 * the originally requested URL as `?returnUrl=` so LoginComponent can
 * resume the navigation after a successful sign-in.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  const token = safeGetItem('session', 'auth_token');
  const user = userService.getCurrentUser();

  if (token && user) {
    return true;
  }

  const returnUrl = state?.url && state.url !== '/login' ? state.url : undefined;
  return router.createUrlTree(['/login'], returnUrl ? { queryParams: { returnUrl } } : undefined);
};
